import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import { Tooltip } from 'react-bootstrap';
import $ from 'jquery';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as flowsHistoryActions from '../../actions/flows_history/index';

/* Components */
import Header from '../../components/flows_history/header';
import Title from '../../components/flows_history/title';
import FlowsTable from '../../components/flows_history/flowsTable';
import ModalViewComments from '../../components/flow_admin_detail/modalViewComments';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class FlowsHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalViewComments: false,
      viewComments: ""
    };
  }

  componentWillUnmount() {
    this.props.actions.reset();
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('flowrequestsapplicant') 
      || permits.includes('flowrequestsadmin');

    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);

        if (obj.generalSetting.views.includes('flowrequests')) {
        	const dateStart = this.props.filters.date.fechaStartFinal || null;
      		const dateEnd = this.props.filters.date.fechaEndFinal || null;
          	await this.props.actions.fetchFlowsHistoryApi({
            	dateStart,
            	dateEnd
          	});        
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  handleSubmit = async obj => {
    /* GROUP */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);

    this.props.actions.setFilters({
      date: date
    });
    
    await this.props.actions.fetchFlowsHistoryApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
  };

  handleDownload = async obj => {
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);
    
    await this.props.actions.downloadExcel({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
  };

  handleModalViewComments = e => {
      const comment = JSON.parse(e.target.dataset.datos);
      this.setState({
        showModalViewComments: true,
        viewComments: comment
      });
  };

  handleCloseModalViewComments = e => {
    if (e.target.dataset.close == 'ok') {
      this.setState({
        showModalViewComments: false,
        viewComments: ""
      });
    }
  };

  handleDownloadMopFile = async e => {
    const path = JSON.parse(e.target.dataset.path);
    await this.props.actions.downloadMopFile({
      path: path
    });
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const permits = localStoreFN().getItem('permits');

      const setting = ObjGeneral.getSetting({
        setting: obj.tasksManager,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const { graphColorRange } = obj;
      const language = this.props.language ? this.props.language : '';
      return (
        <section className="main flows-history">
          {(this.props.loading) ? (
            <Loading language={this.props.language} />
          ) : this.props.status === 401 ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : (this.props.status === 200) ? (
            <div>
              <Header
                language={this.props.language}
                filters={this.props.filters}
                handleSubmit={this.handleSubmit}
                datos={this.props.datos}
                handleDownload={this.handleDownload}
              />
              <div className="main-container scroll">
                <Title language={this.props.language} />
                <div className="table-row">
                  <FlowsTable
                    data={this.props.datos.flowRequests}
                    isAdmin={permits.includes('flowrequestsadmin')}
                    handleModalViewComments={this.handleModalViewComments}
                    handleDownloadMopFile={this.handleDownloadMopFile}
                    language={this.props.language}
                  />
                </div>
                <ModalViewComments
                  handleClose={this.handleCloseModalViewComments}
                  showModal={this.state.showModalViewComments}
                  comments={this.state.viewComments}
                  language={this.props.language}
                />
                <Tooltip placement="top" id="pageTooltip" />
              </div>
            </div>
          ) : this.props.status === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}
const mapStateToProps = state => ({
  language: state.reducer.dashboard.language,
  setting: state.reducer.dashboard.setting,
  datos: state.reducer.flowsHistory.datos,
  loading: state.reducer.flowsHistory.loading,
  status: state.reducer.flowsHistory.status,
  filters: state.reducer.flowsHistory.filters
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(flowsHistoryActions, dispatch)
});
FlowsHistory.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlowsHistory);



// WEBPACK FOOTER //
// ./source/client/containers/flows_history/index.jsx